import * as angular from 'angular';
import * as _ from "lodash";
import { CheckListInstancesService } from '../checkLists/checkListInstances.service';
import { apsCommands } from '../../shared/dto/aps.commands';
import { NotificationService } from "../../services/notifications/notification.service";

export interface WebApiErrors {
  modelState?: { [name: string]: string; };
}

export interface ApiErrors {
  data?: WebApiErrors;
}

export interface NotifyService {
  success(msg: string, title?: string): void;
  error(msg: string, title?: string): void;
  alertMold(
    checkListInstancesServices: CheckListInstancesService,
    command: apsCommands.WellKnownCheckListCreate,
    msg: string,
    title?: string): void;
  alertBlank(
    checkListInstancesServices: CheckListInstancesService,
    command: apsCommands.WellKnownCheckListCreate,
    msg: string,
    title?: string): void;
  alertWeigh(
    checkListInstancesServices: CheckListInstancesService,
    command: apsCommands.WellKnownCheckListCreate,
    msg: string,
    title?: string): void;
  warning(msg: string, title?: string): void;
  warning15(msg: string, title?: string): void;
  alertCritical(notificationService: NotificationService, notificationId: string, msg: string, title?: string): void;
  handleApiErrors(errors: ApiErrors, title?: string): void;
}

export default angular.module('aps.services.notify', ['toastr'])
  .service('notifyService', notifyService)
  .name;

function notifyService(toastr: any): NotifyService {
  function success(msg: string, title?: string): void {
    toastr.success(msg, title);
  }
  function error(msg: string, title?: string): void {
    toastr.error(msg, title);
  }
  function warning(msg: string, title?: string): void {
    toastr.warning(msg, title);

  }
  function alertWeigh(
    checkListInstancesServices: CheckListInstancesService,
    command: apsCommands.WellKnownCheckListCreate,
    msg: string,
    title?: string): void {
    toastr.error(msg, title, {
      timeOut: 0, closeButton: true, extendedTimeOut: 0, onShown: function () {
        checkListInstancesServices.wellKnownCreate(command);
      }, onHidden: function () {
        command.WellKnownCheckListResult = 1;
        checkListInstancesServices.wellKnownCreate(command);
      }
    });
  }
  function alertMold(
    checkListInstancesServices: CheckListInstancesService,
    command: apsCommands.WellKnownCheckListCreate,
    msg: string,
    title?: string): void {
    toastr.error(msg, title, {
      timeOut: 0, closeButton: true, extendedTimeOut: 0, onShown: function () {
        checkListInstancesServices.wellKnownCreate(command);
      }, onHidden: function () {
        command.WellKnownCheckListResult = 1;
        checkListInstancesServices.wellKnownCreate(command);
      }
    });
  }
  function alertBlank(
    checkListInstancesServices: CheckListInstancesService,
    command: apsCommands.WellKnownCheckListCreate,
    msg: string,
    title?: string): void {
    toastr.error(msg, title, {
      timeOut: 0, closeButton: true, extendedTimeOut: 0, onShown: function () {
        checkListInstancesServices.wellKnownCreate(command);
      }, onHidden: function () {
        command.WellKnownCheckListResult = 1;
        checkListInstancesServices.wellKnownCreate(command);
      }
    });
  }
  function warning15(msg: string, title?: string): void {
    toastr.warning(msg, title, { timeOut: 0, closeButton: true, extendedTimeOut: 0 });
  }
  function alertCritical(notificationService: NotificationService,
    notificationId: string, msg: string, title?: string): void {

    toastr.error(msg, title, {
      timeOut: 0, closeButton: true, extendedTimeOut: 0, preventDuplicates: true, preventOpenDuplicates: true, onHidden: function () {
        notificationService.readNotification(notificationId);
      }, onShown: function () {
        $('.toast-error').each(function (i, obj) {
          if (i > 0) {
            $(this).hide();
          }
        });
      }
    });
  }
  function handleApiErrors(errors: ApiErrors, title?: string): void {
    if (!errors.data || !errors.data.modelState) {
      if (errors.data) {
        if (errors.data["exceptionMessage"] != null) {
          error(errors.data["exceptionMessage"], title);
        } else if (errors.data[""]) {
          error(errors.data[""][0]);
        } else {
          error('An unknown error occurred', title);
        }
        return;
      }
    }

    _.keys(errors.data.modelState).forEach((key: string) => {
      _.forEach(errors.data.modelState[key], (modelError: string) => {
        error(modelError, title);
      });
    });
  }

  return {
    success: success,
    error: error,
    warning: warning,
    warning15: warning15,
    alertMold: alertMold,
    alertBlank: alertBlank,
    alertWeigh: alertWeigh,
    handleApiErrors: handleApiErrors,
    alertCritical: alertCritical
  };
}


// WEBPACK FOOTER //
// ./src/app/services/notify/notify.service.ts